module.exports = __webpack_public_path__ + "static/Site-4-39f5e17ad47c446ca6e0f28cb66b5075.jpg";